import BasicCard from "../../../../../components/card/basiccard/BasicCard";
import Heading from "../../../../../components/heading/Heading";
import { HEADING } from "../../../../../components/heading/constants/constants";
import Icons from "../../../../../components/icons/Icons";
import { VEC_ICON_NAME } from "../../../../../components/icons/constants";
import styles from './BulkUploadSuccess.styles'
import commonStyles from '../../AddPayerCommonStyles.styles'
import Button from "../../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../../components/button/constants";
import { componentKey } from "../BulkUploadSlice";
import { useDispatch, useSelector } from "react-redux";
import { downloadErroReport } from "../BulkUploadSaga";
import { componentKey as addPyaerComponentKey } from "../../AddPayerSlice"
import { PAGE_STATE } from "../../../../constants/constants";
import { componentKey as authenticationKey } from "../../../../authentication/AuthenticationSlice";
import { setMethodType } from "../../AddPayerSlice";
import { PAYER_SECTION_ROUTES } from "../../../../payerssection/constants";
import useTxNavigate from "../../../../../../libs/txnavigate/TxNavigateHook";


export default function BulkUploadSuccess({ setRefreshStep = () => { }, payerLabel = "Payer" }) {

    const navigate = useTxNavigate();
    const dispatch = useDispatch();

    const { loadingState } = useSelector((state) => state[addPyaerComponentKey]);
    const { validationStatus } = useSelector((state) => state[componentKey]);
    const { isTaxIdError, success, successfullyAddedPayers, payersWithErrors } = validationStatus;

    const { signedInUser } = useSelector((state) => state[authenticationKey]);

    return (
        <>
            {loadingState.state != PAGE_STATE.LOADING && <div style={commonStyles.addPayerSuccessContainer}>

                <BasicCard alignItems="center" customStyles={styles.bacisCard}>
                    <Icons familyName="vec" iconName={VEC_ICON_NAME.BULK_PAYER_ADDED_SUCCESS} />

                    {isTaxIdError &&
                        <>
                            <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>
                                So sorry, {signedInUser?.FirstName ? signedInUser.FirstName : signedInUser?.LastName}!
                            </Heading>
                            <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>
                                We have not added any {payerLabel}s because some {payerLabel}s in your sheet have missing Tax IDs. Please ensure all Tax IDs are filled in and upload the sheet again.
                            </Heading>
                        </>
                    }

                    {success &&
                        <>
                            <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>Congratulations, {signedInUser?.FirstName ? signedInUser.FirstName : signedInUser?.LastName}!</Heading>
                            {validationStatus?.message && <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>{validationStatus.message}</Heading>}
                            <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>All the {successfullyAddedPayers ? successfullyAddedPayers : ""} {payerLabel}s got processed.</Heading>
                        </>
                    }

                    {!success && !isTaxIdError &&
                        <>
                            <Heading type={HEADING.H1} customStyle={commonStyles.cardHeading}>
                                So sorry, {signedInUser?.FirstName ? signedInUser.FirstName : signedInUser?.LastName}!
                            </Heading>
                            <Heading type={HEADING.H2} customStyle={commonStyles.cardSubHeading}>
                                {successfullyAddedPayers == 0 ?
                                    `We have not added any ${payerLabel}s because there are errors in your sheet. None of the ${payerLabel} records are valid.` :
                                    `We have not added any ${payerLabel}s because there are some errors in your sheet. Only ${successfullyAddedPayers} ${payerLabel} records are valid.`
                                }
                            </Heading>
                        </>
                    }


                    {/* Uncomment this code to show the count of Business and Individual types of payers */}
                    {/* <div style={styles.payerCounts}>
                        <div style={styles.individualPayer}>
                            <Icons familyName="vec" iconName={VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL_SMALL} />
                            <span style={styles.payerType}>7 Individual</span>
                        </div>
                        <div style={styles.individualPayer}>
                            <Icons familyName="vec" iconName={VEC_ICON_NAME.PAYER_TYPE_BUSINESS_SMALL} />
                            <span style={styles.payerType}>3 Business</span>
                        </div>
                    </div> */}

                    <div style={commonStyles.grayBorder}></div>

                    {(payersWithErrors > 0) && <>
                        <label style={commonStyles.payerName}>
                            There are <span style={styles.errorText}>{payersWithErrors} {payerLabel}s with errors.</span>
                        </label>

                        <div style={styles.individualPayer} onClick={() => dispatch(downloadErroReport())}>
                            <Icons familyName="vec" iconName={VEC_ICON_NAME.DOWNLOAD_ICON_V2} />
                            <label style={styles.errorReport}>Download error report</label>
                        </div>
                    </>}

                </BasicCard>

                <p style={commonStyles.questionText}>What would you like to do next?</p>

                <div style={commonStyles.buttonsContainer}>
                    <Button
                        type={BUTTON_TYPE.PRIMARY}
                        style={commonStyles.button}
                        onClickCb={() => navigate(`/${PAYER_SECTION_ROUTES.PAYER}`)}
                    >
                        View added {payerLabel}s
                    </Button>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => {
                            navigate(`/${PAYER_SECTION_ROUTES.PAYER}/${PAYER_SECTION_ROUTES.ADD}`)
                            dispatch(setMethodType(null))
                            setRefreshStep(0)
                        }}
                    >
                        Add another {payerLabel}
                    </Button>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        style={commonStyles.button}
                        onClickCb={() => navigate(`/`)}
                    >
                        Go to dashboard
                    </Button>
                </div>
            </div>}
        </>
    )
}
